import React from 'react';
import CTAButton from './CTAButton';

export default function Hero({ lang }) {
  return (
    <section className="w-full pt-16 pb-12 sm:pt-24 sm:pb-16 flex flex-col gap-8">
      <div className="border-l-8 border-amber-400 pl-4 sm:pl-6">
        <h1 className="text-6xl sm:text-8xl font-black uppercase leading-[0.9] tracking-tighter">
          <span className="text-amber-400">Barbera del Vallès  Beer Pass </span><br/>
         
        </h1>
      </div>
      
      <p className="text-xl sm:text-2xl font-bold max-w-xl text-gray-300 uppercase leading-snug">
        {lang === 'en' 
          ? 'The ultimate local beer pass. Valid at 10 top taprooms. No bullshit.' 
          : 'El mejor pase de cerveza local. Válido en 10 cervecerías top. Sin excusas.'}
      </p>
      
      <div className="mt-4">
        <CTAButton lang={lang} />
      </div>
    </section>
  );
}